import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-illustrative/lamp.svg';
import { mapGetters, mapMutations } from 'vuex';
import MdmBreadcrumb from '~/components/atoms/Global/MdmBreadcrumb.vue';
import SearchSeo from '~/components/functional/Seo/SearchSeo.vue';
import CategoryLoading from '~/components/templates/Category/CategoryLoading.vue';
import CategoryTemplate from '~/components/templates/Category/CategoryTemplate.vue';
import ResultsDataProvider from '~/components/specific/Providers/ResultsDataProvider.vue';
import getCorvusProviderName from '~/helpers/search-data-helpers';
import { componentList, typeDefinition, buildSlices } from '~/helpers/editorial-helper';
import { fetchContent } from '~/services/editorial';
var components = {};
componentList().forEach(function (e) {
  components[e.type || e.name] = function (slug) {
    return {
      component: import("~/components/organisms/Editorial/".concat(slug))
    };
  };
});
export default {
  components: {
    MdmBreadcrumb: MdmBreadcrumb,
    SearchSeo: SearchSeo,
    CategoryLoading: CategoryLoading,
    CategoryTemplate: CategoryTemplate,
    ResultsDataProvider: ResultsDataProvider
  },
  httpHeaders: function httpHeaders() {
    return {
      'Cache-Control': 'max-age=0, s-maxage=86400, public'
    };
  },
  asyncData: function asyncData(_ref) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var apolloProvider, store, definition, _yield$fetchContent, _yield$fetchContent$r, _yield$fetchContent$r2, id, data, slices;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              apolloProvider = _ref.app.apolloProvider, store = _ref.store;
              _context.prev = 1;
              definition = typeDefinition('noresult');
              _context.next = 5;
              return fetchContent(store, {
                type: 'noresult'
              });

            case 5:
              _yield$fetchContent = _context.sent;
              _yield$fetchContent$r = _slicedToArray(_yield$fetchContent.results, 1);
              _yield$fetchContent$r2 = _yield$fetchContent$r[0];
              id = _yield$fetchContent$r2.id;
              data = _yield$fetchContent$r2.data;
              _context.next = 12;
              return buildSlices(definition, data, apolloProvider.defaultClient, store);

            case 12:
              slices = _context.sent;
              return _context.abrupt("return", {
                type: definition.type,
                template: {
                  path: definition.path,
                  data: data
                },
                id: id,
                slices: slices
              });

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](1);
              console.log(_context.t0);

            case 19:
              return _context.abrupt("return", false);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 16]]);
    }))();
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    descriptionSeo: function descriptionSeo() {
      return this.description && this.description.seo && this.description.seo.meta_description ? this.description.seo.meta_description : '';
    },
    dataProvider: function dataProvider() {
      if (getCorvusProviderName(this) === 'algolia') {
        return false;
      }

      return true;
    },
    speedcurveConfig: function speedcurveConfig() {
      var luxConfig = {
        innerHTML: 'LUX = window.LUX || {}; LUX.label = "search";'
      };
      return luxConfig;
    }
  }),
  created: function created() {
    var _this = this;

    if (this.template && this.template.path) {
      this[this.type] = function () {
        return components[_this.type](_this.template.path);
      };
    }

    if (this.slices) {
      this.slices.forEach(function (_ref2) {
        var type = _ref2.type,
            path = _ref2.path;

        _this[type] = function () {
          return components[type](path);
        };
      });
    }

    this.setTcvarsTemplateName('listproduct_keyword');
  },
  methods: _objectSpread({
    currentComponent: function currentComponent(arg) {
      return this[arg];
    }
  }, mapMutations({
    setTcvarsTemplateName: 'category/SET_TCVARS_TEMPLATE_NAME'
  })),
  head: function head() {
    return {
      script: [this.speedcurveConfig]
    };
  }
};